module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-TO.a4d7a2a6.png";